function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#fff;opacity:0.3;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M22.278,673.019l.1-.061.047.024c3.015,1.736,9.042,5.216,9.042,5.216l0,1.921,1.588-.9,1.681.965V690.7l-.089.1L24,696.936a.185.185,0,0,1-.146.011c-.044-.019-.127-.066-.127-.066l-10.5-6.049-.1-.057-.039.023-1.592.918-.005-3.83,3.8,1.437L11.49,686.9l0-1.014,5.573,2.395-5.572-3.45,0-.955,7.319,3.351-7.324-4.483,0-.868,8.815,4.179-8.815-5.381-.008-1.481s7.2-4.115,10.8-6.175m-1.682,11.4.018,1.934,10.342-5.936.005-.131,0-1.784L20.6,684.423M15.617,691.3l8.274-3.847,0,.856-6.541,4.008,6.539-2.987,0,.843L18.966,693.4l.145-.052,4.783-2.088,0,.794-3.307,2.434,3.309-1.3v.89l-1.7,1.511,1.7-.489,0,1.141,10.127-5.785.117-.122,0-9.766Z",
  transform: "translate(-11.48 -672.958)"
});

var SvgLogoSimbolInfp = function SvgLogoSimbolInfp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 23.258,
    height: 24,
    viewBox: "0 0 23.258 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoSimbolInfp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_simbol_INFP.e0a9ec69.svg";
export { ForwardRef as ReactComponent };